<template>
  <div>

  <Cmodal
      v-model="open"
      centered
      size="md"
      title="Give Credit (Comp & Discount)"
      :tag="false"
      @submit="submit"
      @hide="hide"
    >
      <template>
        <b-input-group prepend="Credit Amount ($)">
          <b-input
            v-model="orderCredit"
            type="number"
            name="Credit Amount"
          />
        </b-input-group>
        <ul class="percent my-3 mb-5 px-2 d-flex flex-row justify-content-between">
          <li
            v-for="(item, index) in percents"
            :key="index"
            class="py-2"
            style="cursor:pointer"
            @click="calcCreditByPercent(item)"
            :class="{
              'active-percent': percent === item
            }"
          >
            <span v-if="!item">
              ZERO
            </span>
            <span v-else>
              {{ item + '%' }}
            </span>
          </li>
        </ul>
        <section>
          <div class="h4 mb-3">
            Reason for Credit:
          </div>
          <b-form-group v-slot="{ariaDescribedby}">
            <b-form-radio-group
              size="lg"
              id="refundReasons"
              v-model="Reason"
              :aria-describedby="ariaDescribedby"
              name="Reason"
            >
              <b-form-radio style="margin-bottom: 20px" value="Promotions">Promotions</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Guest Relations">Guest Relations</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Staff Meals">Staff Meals</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Owner Meals">Owner Meals</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Cash (No-Penny) Rounding">Cash (No-Penny) Rounding</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Other">Other</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </section>
        <p v-if="errReason" class="px-4 text-danger text-center" style="font-size:large">
            * Please select a reason
        </p>
        <p v-if="errAmmount" class="px-4 text-danger text-center" style="font-size:large">
            * Amount must be lower than total
        </p>
      </template>
      <template #actions="{ submit, hide }">
        <b-row class="flex-grow-1">
          <b-col cols="6">
            <b-btn variant="warning" block class="text-nowrap credit-modal-btn" @click="submit">
              Apply Credit
            </b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn variant="danger" block class="text-nowrap credit-modal-btn cancel-btn-cmodal" @click="hide">
              Never mind
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </Cmodal>
  </div>

</template>

<script>
import Cmodal from '../../shared/Cmodal.vue'
export default {
    
name:"Credit",
components:{
    Cmodal,
},
props:{
    total:{type:Number,required:true},
    model:{type:Object, required:false}
},
data(){
    return{
        Reason:"",
        percents: [0, 10, 30, 50, 70, 100],
        orderCredit:0,
        percent:0,
        open:false,
        errReason:false,
        errAmmount:false
        
    }
},
created(){
    if(this.model.ammount!=0){
        this.orderCredit = this.model.ammount
        this.Reason = this.model.reason    
    }
    setTimeout(()=>{
        this.open = true
    },100)
    
    
},

methods:{
    calcCreditByPercent(percent){
        this.percent = percent
        this.orderCredit = ((percent * this.total) / 100).toFixed(2)

    },
    submit(){
        this.errReason = false
        this.errAmmount = false
        if(this.Reason === ""){
            return this.errReason = true
        }
        if(parseFloat(this.orderCredit) > this.total){
            return this.errAmmount = true
        }

        let obj = {
            ammount:this.orderCredit,
            reason:this.Reason
        }
        
        this.$emit("apply",obj)
        
        setTimeout(()=>{//for animation
            this.$emit("hide")
        },100)

        this.errReason = false
        this.errAmmount = false

    },
    hide(){
        setTimeout(()=>{//for animation
            this.$emit("hide")
        },100)
        this.errReason = false
        this.errAmmount = false
    }    
}
}
</script>

<style>
.active-percent {
  background: #f5c31c !important;
}
.percent {
  border: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li {
  display: inline-block;
  list-style: none;
  width: 20%;
  text-align: center;
  border-right: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li:hover {
  background: #e0b700;
}
.percent li:last-child {
  border-right: none;
}
.credit-modal-btn {
  font-size: 1.3rem;
  height: 3rem;
}
</style>